<template>
<div>
  <v-layout>
    <v-flex xs12>
      <v-radio-group style="font-size: 15px;position:relative" v-if="editable" v-model="model">
        <v-radio class="radio" v-for="(value) in field.values" :key="value.key" :label="`${value.value}`" :value="value.key"></v-radio>
        <v-icon style="position:absolute;top:-5px;right:-30px;cursor:pointer;z-index:2000" @click="updateOrigin" v-if="isEdited() && editable" class="light-green--text">check</v-icon>

      </v-radio-group>

      <div v-else>
        <span v-if="isBaseValid()">
          {{ valueToShow }}
        </span>
        <v-tooltip v-else top>
          <template v-slot:activator="{ on }">
            <span class="incorrect block-span" v-on="on">{{ valueToShow | notEmpty }}</span>
          </template>
          <span>{{ validation.message }}</span>
        </v-tooltip>
      </div>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import {
  input
} from '@/mixins/input'
import InputHelper from '@/plugins/InputHelper'
import NumberValidator from '@/plugins/validator/number/NumberValidator'
import fieldType from '@/enums/fieldType'

export default {
  props: ["valueField", "editable", "field", "validation", "context"],
  watch: {
    editable: function(newVal) {
      if (!newVal && this.isEdited())
        this.reset();
    },
    valueField: function(newVal) {
      this.valueToShow = newVal
      this.model = this.setUpModel(newVal)
    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  data() {
    return {
      modelx: "",
      valueToShow: ""
    }
  },
  methods: {
    isBaseValid() {
      return this.validation.pass
    },
    setUpModel(value) {
      return InputHelper.getRadioObjectByValue(this.field, value) != undefined ?
        InputHelper.getRadioObjectByValue(this.field, value).key : this.valueField
    },
    updateOrigin() {
      this.$emit("updateField", this.model)
    },
    isEdited() {
      return InputHelper.getRadioObjectByValue(this.field, this.valueField) != undefined ?
        (InputHelper.getRadioObjectByValue(this.field, this.valueField).key != this.model) : (this.model != this.valueField)
    },
    reset() {
      this.model = this.setUpModel(this.valueField)
    },
    getCustomPresentationValue(model) {
      return model;
    },
  },
  created() {
    this.model = this.setUpModel(this.valueField)
    this.valueToShow = this.valueField
  },
  mixins: [input]
}
</script>

<style scope>
.radio>label {
  font-size: 11px !important;
}
.block-span{
  display: block;
}

.radio {}
</style>
